/* This is the EMIS Staff Salary components */

<template>
  <v-container>
    <div>
      <span v-html="title"></span>
    </div>
    <div>
      <table border="1px;" cellspacing="0px;">
        <tbody>
          <tr>
            <td style="width: 220px; text-align: center; vertical-align: middle" rowspan="2">អ្នកប្រើប្រាស់</td>
            <td style="width: 100px; text-align: center" colspan="2">ចំនួនអគារ</td>
            <td style="width: 100px; height: 25px; text-align: center" colspan="2">ចំនួនបន្ទប់</td>
            <td style="width: 100px; height: 25px; text-align: center" colspan="2">ចំនួនបន្ទប់បានប្រើស្នាក់នៅ</td>
            <td style="width: 100px; height: 25px; text-align: center" colspan="2">ចំនូនមនុស្សស្នាក់នៅ</td>            
          </tr>
          <tr style="height: 25px; text-align: center">
            <td style="width: 50px">សរុប</td>
            <td style="width: 50px">ស្រី</td>
            <td style="width: 50px">សរុប</td>
            <td style="width: 50px">ស្រី</td>
            <td style="width: 50px">សរុប</td>
            <td style="width: 50px">ស្រី</td>
            <td style="width: 50px">សរុប</td>
            <td style="width: 50px">ស្រី</td>
          </tr>
          <tr
            v-for="(value, row) in d4.length"
            :key="row"
            style="height: 25px; text-align: left"
          >
            <td style="width: 220px; height: 25px">{{ d4[row] }}</td>
            <td style="width: 60px; height: 25px">
              <numberinput v-model="data[row].dt[0]" style="width: 50px; text-align: center;" />
            </td>
            <td style="width: 60px; height: 25px">
              <numberinput v-model="data[row].dt[1]" style="width: 50px; text-align: center;" />
            </td>
            <td style="width: 60px; height: 25px">
              <numberinput v-model="data[row].dt[2]" style="width: 50px; text-align: center;" />
            </td>
            <td style="width: 60px; height: 25px">
              <numberinput v-model="data[row].dt[3]" style="width: 50px; text-align: center;" />
            </td>
            <td style="width: 60px; height: 25px">
              <numberinput v-model="data[row].dt[4]" style="width: 50px; text-align: center;" />
            </td>
            <td style="width: 60px; height: 25px">
              <numberinput v-model="data[row].dt[5]" style="width: 50px; text-align: center;" />
            </td>
            <td style="width: 60px; height: 25px">
              <numberinput v-model="data[row].dt[6]" style="width: 50px; text-align: center;" />
            </td>
            <td style="width: 60px; height: 25px">
              <numberinput v-model="data[row].dt[7]" style="width: 50px; text-align: center;" />
            </td>
          </tr>
          <!-- Total Row data, last two columns do not draw and sum -->
          <tr style="height: 25px; text-align: center">
            <td style="width: 150px; height: 25px">សរុប</td>
            <td
              v-for="(value, col) in totalRow.length"
              :key="col"
              style="width: 50px; height: 25px"
            >
              {{ totalRow[col] }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </v-container>
</template>

<script>
import { d4 } from "@/utils/ascf/commonConfig.js";
import NumberInput from "@/components/common/NumberInput.vue";
export default {
  props: ["data", "title"],
  components: {
    numberinput: NumberInput,
  },
  data() {
    return {
      d4: d4,
    };
  },
  computed: {
    // need to update the total staff in json data
    totalRow: function () {
      let result;
      let d = this.data;
      let ldata = this.data.length;

      result = d.reduce(function (r, a, ind) {
        a.dt.forEach(function (b, i) {
          if (ind < ldata) {
            // do summing 0 to last - 1 only (last is sum array)
            r[i] = (r[i] || 0) + Number(b);
          }
        });
        return r;
      }, []);
      // update the total row array in JSON
      /*
      d[ldata].dt.forEach(function (b, i) {
        d[ldata].dt[i] = result[i];
      });
      */
      return result;
    },
  },
};
</script>
<style scoped>
.td-white {
  width: 60px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
  background-color: white;
}
</style>